import type { PageContext } from '@zto/zpage'

import { commonOptions, EnableStatus } from '@/config'

import { addEditDialog } from './_dialogs'
import { getTableStatusEditor } from '@/utils'

export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/sys/admin/device/manufacturer/pageList'
      },
      add: {
        api: '/sys/admin/device/manufacturer/create',
        dialog: addEditDialog(false)
      },
      edit: {
        api: '/sys/admin/device/manufacturer/edit',
        dialog: addEditDialog(true)
      },
      export: {}
    },
    search: {
      items: [
        { type: 'input', prop: 'manufacturerName', label: '厂商名称' },
        { type: 'input', prop: 'manufacturerCode', label: '厂商编码' }
      ]
    },
    toolbar: {
      items: [{ action: 'add', label: '新增' }]
    },
    table: {
      editable: true,
      innerAttrs: { rowKey: 'manufacturerCode' },
      operation: {
        width: 100,
        items: [{ action: 'edit' }]
      },
      columns: [
        { label: '厂商编码', prop: 'manufacturerCode', width: 120 },
        { label: '厂商名称', prop: 'manufacturerName', width: 120 },
        { label: '联系人', prop: 'contact', width: 120 },
        { label: '电话', prop: 'phone', width: 120 },
        { label: '备注', prop: 'remark', minWidth: 120 },
        { label: '供货范围', prop: 'supplyScopeNames', width: 180 },
        { label: '设备数', prop: 'deviceCount', width: 100 },
        {
          label: '状态',
          prop: 'status',
          formatter: { name: 'enumStr', options: commonOptions.enableStatus },
          width: 120,
          editor: getTableStatusEditor({
            api: '/sys/admin/device/manufacturer/changeStatus',
            apiParams: (model: any) => ({ manufacturerCode: model.manufacturerCode })
          })
        }
      ]
    }
  }
}
